export const isValidCpf = (strCpf = '') => {
  strCpf = strCpf.replace(/\D/g, '')
  if (
    strCpf.length !== 11 ||
    strCpf === '00000000000' ||
    strCpf === '11111111111' ||
    strCpf === '22222222222' ||
    strCpf === '33333333333' ||
    strCpf === '44444444444' ||
    strCpf === '55555555555' ||
    strCpf === '66666666666' ||
    strCpf === '77777777777' ||
    strCpf === '88888888888' ||
    strCpf === '99999999999'
  ) {
    return false
  }

  let sum = 0
  let rest
  for (let i = 1; i <= 9; i += 1) {
    sum += parseInt(strCpf.substring(i - 1, i), 10) * (11 - i)
  }

  rest = (sum * 10) % 11
  if (rest === 10 || rest === 11) {
    rest = 0
  }

  if (rest !== parseInt(strCpf.slice(9, 10), 10)) {
    return false
  }

  sum = 0
  for (let i = 1; i <= 10; i += 1) {
    sum += parseInt(strCpf.substring(i - 1, i), 10) * (12 - i)
  }

  rest = (sum * 10) % 11
  if (rest === 10 || rest === 11) {
    rest = 0
  }

  if (rest !== parseInt(strCpf.slice(10, 11), 10)) {
    return false
  }

  return true
}

export const isValidCnpj = (arg = '') => {
  let strCnpj = arg
  let size
  let numbers
  let sum
  let pos
  let result
  strCnpj = strCnpj.replace(/\D/g, '')

  if (strCnpj === '' || strCnpj.length !== 14 || /^(\d)\1+$/.test(strCnpj)) {
    return false
  }

  size = strCnpj.length - 2
  numbers = strCnpj.slice(0, Math.max(0, size))
  const digits = strCnpj.slice(Math.max(0, size))
  sum = 0
  pos = size - 7
  for (let i = size; i >= 1; i -= 1) {
    sum += numbers.charAt(size - i) * pos
    pos -= 1
    if (pos < 2) {
      pos = 9
    }
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
  if (String(result) !== digits.charAt(0)) {
    return false
  }

  size += 1
  numbers = strCnpj.slice(0, Math.max(0, size))
  sum = 0
  pos = size - 7
  for (let i = size; i >= 1; i -= 1) {
    sum += numbers.charAt(size - i) * pos
    pos -= 1
    if (pos < 2) {
      pos = 9
    }
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
  if (String(result) !== digits.charAt(1)) {
    return false
  }

  return true
}
